module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BoldCondIt.cdb7be4.ttf";